module.exports = __webpack_public_path__ + "src/assets/textures/petri/incubator_lambert1_AO.jpg";